import API from 'services/API';
import { formatAddress } from 'utils';

export default function searchInspection(data) {
  return API.request({
    method: 'POST',
    url: '/findTaxAuthority',
    data,
    mapper: function (data = []) {
      return data.map((taxAuthority) => {
        taxAuthority.address = formatAddress(taxAuthority.fnsAddress);
        return taxAuthority;
      });
    },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
